module.exports = __webpack_public_path__ + "static/media/cvv.1a7e7616.svg";